module.exports = __webpack_public_path__ + "static/media/blog1.81b04cee.jpg";